/* ===========================================
   Mobile Select Truncation for Quick Buy Cards
   Truncates option text in closed state,
   shows full text when dropdown is opened.
   =========================================== */

(function() {
  // Prevent duplicate initialization
  if (window.__quickBuyTruncationInit) return;
  window.__quickBuyTruncationInit = true;

  window.quickBuyTruncateSelect = function(select) {
    if (window.innerWidth > 749) return;
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;
    var shortText = selectedOption.getAttribute('data-short-text');
    if (shortText && shortText.length > 32) {
      selectedOption.textContent = shortText.substring(0, 30) + '...';
    } else if (shortText) {
      selectedOption.textContent = shortText;
    }
  };

  function restoreSelect(select) {
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var fullText = opt.getAttribute('data-full-text');
      if (fullText) {
        opt.textContent = fullText;
      }
    }
  }

  window.quickBuyRestoreSelect = restoreSelect;

  function setupSelect(select) {
    if (select.__truncationSetup) return;
    select.__truncationSetup = true;

    window.quickBuyTruncateSelect(select);

    select.addEventListener('focus', function() {
      restoreSelect(this);
    });

    select.addEventListener('blur', function() {
      var self = this;
      setTimeout(function() { window.quickBuyTruncateSelect(self); }, 150);
    });
  }

  function initAll() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.quick-buy-card__select').forEach(setupSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Watch for dynamically added cards
  var observer = new MutationObserver(function() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.quick-buy-card__select').forEach(setupSelect);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
